import { AgGridReact } from "ag-grid-react";
import type { ColDef, RowClickedEvent } from "ag-grid-community";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { defaultColDef } from "./defaults";

ModuleRegistry.registerModules([AllCommunityModule]);

interface AdminTableProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rowData: any[];
  columnDefs: ColDef[];
  onRowClicked: (event: RowClickedEvent) => void;
}

export const AdminTable = ({
  rowData,
  columnDefs,
  onRowClicked,
}: AdminTableProps) => {
  return (
    <>
      <div style={{ height: "70vh" }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onRowClicked={onRowClicked}
          gridOptions={{
            rowStyle: { cursor: "pointer" },
            autoSizeStrategy: {
              type: "fitCellContents",
            },
          }}
        />
      </div>
    </>
  );
};
